import { createContext } from 'react';

const TableSectionContext = createContext('body');

export default TableSectionContext;
